import { cn } from '@/lib/utils';

interface Stat {
  value: string;
  label: string;
}

interface StatsSectionProps {
  content: {
    title?: string;
    stats?: Stat[];
  };
  variant?: string;
  layoutStyle?: string;
}

export function StatsSection({ content, variant = 'default', layoutStyle = 'classic' }: StatsSectionProps) {
  const {
    title,
    stats = [],
  } = content;

  const isMinimal = layoutStyle === 'modern-minimal';
  const isBold = layoutStyle === 'bold-geometric';
  const isPlayful = layoutStyle === 'playful-rounded';

  if (stats.length === 0) return null;

  return (
    <section className={cn(
      "section-padding",
      variant === 'alt-bg' ? "bg-secondary/30" : "bg-background"
    )}>
      <div className="container mx-auto px-4">
        {title && (
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground text-center mb-12">
            {title}
          </h2>
        )}

        <div className={cn(
          "grid gap-6",
          stats.length === 2 && "grid-cols-2 max-w-xl mx-auto",
          stats.length === 3 && "grid-cols-3 max-w-3xl mx-auto",
          stats.length >= 4 && "grid-cols-2 md:grid-cols-4"
        )}>
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className={cn(
                "text-center p-6",
                isMinimal ? "border-l-2 border-foreground" :
                isBold ? "border-2 border-foreground" :
                isPlayful ? "bg-secondary/50 rounded-3xl" :
                "bg-card rounded-2xl shadow-sm"
              )}
            >
              <p className={cn(
                "font-display font-bold text-primary mb-1",
                isBold ? "text-4xl md:text-5xl" : "text-3xl md:text-4xl"
              )}>
                {stat.value}
              </p>
              <p className={cn(
                "text-muted-foreground",
                isBold ? "uppercase tracking-wide text-xs" : "text-sm"
              )}>
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}